import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index17.css';const sm = "_sm_ceja5_1";
const md = "_md_ceja5_8";
const lg = "_lg_ceja5_15";
const xl = "_xl_ceja5_22";
const xxl = "_xxl_ceja5_29";
const s = {
  sm,
  md,
  lg,
  xl,
  xxl
};
const CLASS_NAME_MAP = {
  sm: s.sm,
  md: s.md,
  lg: s.lg,
  xl: s.xl,
  xxl: s.xxl
};
const IconWrapper = forwardRef(
  ({ children, size = "md", className, ...rest }, ref) => (
    // `Slot` does not accept any other type than `HTMLElement`
    /* @__PURE__ */ jsx(Slot, { ...rest, ref, className: clsx(className, CLASS_NAME_MAP[size]), children })
  )
);
export {
  IconWrapper
};
